<template lang="html">
    <BaseWidget>
        <template slot="title">{{ $t("dashboardModule.catalogTitle") }}</template>
        <template slot="content-desktop">
            <ComponentListItem
                :page="'dashboard'"
                :key="item.id"
                v-for="(item, index) in itemList"
                :index="index"
                :item="item"
                :device="'desktop'"
            ></ComponentListItem>
        </template>
        <template slot="content-mobile">
            <swiper :options="swiperOption" ref="mySwiper">
                <!-- slides -->
                <swiper-slide v-for="item in itemList" :key="item.id" class="txtCenter">
                    <div class="swipe-content">
                        <router-link :to="'/' + item.type + '/' + item.id">
                            <figure class="center" :style="{ backgroundImage: 'url(' + getImgPath(item.figures.big, 'big') + ')' }">
                                <img class="hidden" :src="getImgPath(item.figures.big, 'big')" v-if="item.figures.big !== null" alt />
                                <img
                                    src="../../../../static/img/no_image.jpg"
                                    class="ff-medium noPhoto center"
                                    height="200"
                                    width="200"
                                    v-if="item.figures.small === null"
                                />
                            </figure>
                        </router-link>
                        <h3>
                            <span class="ff-bold">{{ getTranslate(item.terms.name) }}</span>
                        </h3>
                    </div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </template>
        <template slot="footer">
            <LinkButton :to="'/catalog'" :text="$t('dashboardModule.seeAllCat')" />
        </template>
    </BaseWidget>
</template>

<script lang="js">
import BaseWidget from "@/components/dashboard/BaseWidget";
import ComponentListItem from "@/components/ComponentListItem/ComponentListItem";
import LinkButton from "@/components/dashboard/elements/LinkButton";
import Globals from "@/components/globals";

export default  {
    components: { LinkButton, BaseWidget, ComponentListItem},
    props: {
        itemList: {
            type: Array,
            required: true
        },
        swiperOption: {
            type: Object,
            required: true
        }
    },
    methods: {
        getImgPath(imgPath, format) {
            return Globals.getBaseUrl() + "/" + imgPath;
        },
    }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
</style>



// WEBPACK FOOTER //
// CatalogueWidget.vue?272d9486